/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdmissionStatusInfo
 */
export interface AdmissionStatusInfo {
    /**
     * 
     * @type {string}
     * @memberof AdmissionStatusInfo
     */
    actioned_by?: string;
    /**
     * 
     * @type {string}
     * @memberof AdmissionStatusInfo
     */
    action_effective_date?: string;
    /**
     * 
     * @type {string}
     * @memberof AdmissionStatusInfo
     */
    scheduled_action_effective_date?: string;
    /**
     * 
     * @type {string}
     * @memberof AdmissionStatusInfo
     */
    comment?: string;
}

/**
 * Check if a given object implements the AdmissionStatusInfo interface.
 */
export function instanceOfAdmissionStatusInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdmissionStatusInfoFromJSON(json: any): AdmissionStatusInfo {
    return AdmissionStatusInfoFromJSONTyped(json, false);
}

export function AdmissionStatusInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionStatusInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actioned_by': !exists(json, 'actioned_by') ? undefined : json['actioned_by'],
        'action_effective_date': !exists(json, 'action_effective_date') ? undefined : json['action_effective_date'],
        'scheduled_action_effective_date': !exists(json, 'scheduled_action_effective_date') ? undefined : json['scheduled_action_effective_date'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function AdmissionStatusInfoToJSON(value?: AdmissionStatusInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'actioned_by': value.actioned_by,
        'action_effective_date': value.action_effective_date,
        'scheduled_action_effective_date': value.scheduled_action_effective_date,
        'comment': value.comment,
    };
}

